import type { FC } from "react";
import { TriggerButton, TriggerButtonGroup } from "widgets";
import type { StoreApi, UseBoundStore } from "zustand";

import type { FileBrowserStore } from "@/modules/files/stores/file-browser.ts";

export interface FileBrowserBreadcrumbWidgetProps {
  useStore: UseBoundStore<StoreApi<FileBrowserStore>>;
}

export const FileBrowserBreadcrumbWidget: FC<FileBrowserBreadcrumbWidgetProps> = (props) => {
  const breadcrumbs = props.useStore((state) => state.breadcrumbs);
  const loading = props.useStore((state) => state.loading);
  const load = props.useStore((state) => state.load);
  const refresh = props.useStore((state) => state.refresh);

  return (
    <TriggerButtonGroup>
      <TriggerButton
        isDisabled={!breadcrumbs || breadcrumbs.length <= 1 || loading}
        onPress={() => {
          if (breadcrumbs) {
            void load(breadcrumbs[breadcrumbs.length - 2].id);
          }
        }}
        label={"Go Up"}
        icon={"reply"}
      />
      <TriggerButton onPress={() => refresh(true)} label={"Refresh"} icon={"sync"} isDisabled={loading} />
    </TriggerButtonGroup>
  );
};
